import React from 'react'

const Footer = () => {
  return (
    <section>
        <div className='container mx-auto text-black border-t-2 border-slate-950'>
            <div className='text-sm flex items-center justify-center font-rubik mt-6 text-accent lg:text-lg'>
                All Right Reserved 2023 | Paul Ivan Dela Cruz
            </div>
        </div>
    </section>
  )
}

export default Footer